import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 2.75A2.74 2.74 0 0 1 2.75 0h9.625a2.77 2.77 0 0 1 2.75 2.75v16.5a2.74 2.74 0 0 1-2.75 2.75H2.75A2.715 2.715 0 0 1 0 19.25zm8.938 16.5c0-.73-.645-1.375-1.376-1.375-.773 0-1.375.645-1.375 1.375 0 .773.602 1.375 1.375 1.375.731 0 1.375-.602 1.375-1.375m3.437-16.5H2.75V16.5h9.625z"
    }, null, -1)
  ]))]))
}
export default { render: render }